export enum Pillar {
    AM = 1,
    QA = 2,
    QAFS = 3,
    EHSS = 4,
    CM = 5,
    LI = 6,
}

export enum PillarNames{
    AM = 'AM',
    QA = 'QA',
    QAFS = 'QAFS',
    EHSS = 'EHSS',
    CM = 'CM',
    LI = 'LI',
    CONFIG = 'CONFIG',
    RS = 'RS',
}